export default "__VITE_ASSET__8af7aa05__"